var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinServiceSitePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 41,
    rx: 6,
    ry: 3,
    fill: "#002A5C",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8384C32 29.0319 20.6455 38.5624 17.0668 41.2386C16.4286 41.7158 15.5714 41.7158 14.9332 41.2386C11.3545 38.5624 0 29.0319 0 15.8384C0 7.09109 7.16344 0 16 0C24.8366 0 32 7.09109 32 15.8384Z",
    fill: "#FFAE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.8384C31 22.1424 28.2864 27.6158 25.0764 31.8812C21.8682 36.1442 18.2154 39.131 16.4679 40.4378C16.1849 40.6494 15.8151 40.6494 15.5321 40.4378C13.7846 39.131 10.1318 36.1442 6.9236 31.8812C3.71362 27.6158 1 22.1424 1 15.8384C1 7.65292 7.70613 1 16 1C24.2939 1 31 7.65292 31 15.8384Z",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5H11V20.1667H13.5V18.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 18.5H17.6667V20.1667H15.1667V18.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3334 8.5H19.3334V15.1667H18.5V11.8333L14.0556 15.1667H13.5V12.0282L7.66669 15.5282V23.5H24.3334V8.5ZM21 10.1667H22.6667V21.8333H21V10.1667ZM19.3334 16.8333H16.8334V15.1667L14.6111 16.8333H11.8334V14.9718L9.33335 16.4718V21.8333H19.3334V16.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinServiceSitePrimary);
export default __webpack_public_path__ + "static/media/pinServiceSitePrimary.8fb99b4f.svg";
export { ForwardRef as ReactComponent };